module.exports = __webpack_public_path__ + "9488d02b/img/document.e2130c6b.svg";